import React, { useEffect, useState } from "react";
import { Button } from "../../components/ui/button";
import ModalComponent from "./modal";
import { FaCreditCard } from "react-icons/fa"; // Importer une icône de carte bancaire
import { useLocation } from "react-router-dom";
import axios from "axios";
import { getDetailsSouscription, paiementSouscription } from "../../lib/apis";
import Loader from "../../components/loader";
import { useTranslation } from "react-i18next";
import { scrollToTop } from "../../lib/utils";

interface Souscription {
  packges: any;
  package_duration: any;
  products: any;
  souscription_id: number;
  user: any
}
const PaieSous = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const souscription = useLocation().state
  const userId = localStorage.getItem("user")
  const [souscriptions, setSouscriptions] = useState<Souscription>(
    {
      packges: {},
      package_duration: {},
      products: {},
      souscription_id: 0,
      user: {}
    }
  )
  const token = localStorage.getItem("token")
  const [number, setNumber] = useState<string>()
  const [loading, setLoading] = useState(true)
  const [loader, setLoader] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    scrollToTop()
  }, [])



  const updateSouscription = async () => {
    try {
      const { data } = await axios.get(`${getDetailsSouscription}/${souscription.data.souscription_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
      console.log(data)
      setSouscriptions(data.souscription)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    updateSouscription()
    // eslint-disable-next-line
  }, [])

  const handlePaie = async () => {
    setLoader(true)
    try {
      await axios.post(paiementSouscription,
        {
          souscription_id: souscriptions.souscription_id,
          user_id: userId,
          transaction_id: souscription.data.transaction_id,
          payment_method: "OM",
          phone_number: number
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )
      setIsModalVisible(true);
    } catch (error) {
      console.log(error)
    } finally {
      setLoader(false)
    }

  };
  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  return (
    <div className="w-full h-full">
      <div className="h-[100px] flex items-center justify-center text-2xl">
        {t("paiement_souscription.frais_transport")}
      </div>

      <div className="grid grid-cols-5 p-8 bg-gray-100 gap-3">
        <div className="col-span-3">
          <div className="bg-white p-6 shadow-lg rounded-lg h-[300px] ">
            <div className="flex flex-col items-start justify-start">
              <div className="text-2xl mt-2">{t("paiement_souscription.service_de_paiement")}</div>

              <div className="text-1xl my-4">{t("paiement_souscription.choisir_methode_paiement")}</div>
              <div className="flex items-center justify-between mb-4 gap-4">
                <div className="flex flex-col items-center mr-4">
                  <FaCreditCard className="text-1xl text-red-500" />
                  <span className="mt-1 text-1xl text-gray-400">
                    credit cart
                  </span>
                </div>
                <div className="flex flex-row">
                  <label className="flex flex-col items-center space-x-4 mr-4">
                    <input type="radio" name="payment" value="OM" />
                    <span className="text-sm text-gray-400">OM</span>
                  </label>
                  <label className="flex flex-col items-center space-x-4 mr-4">
                    <input type="radio" name="payment" value="MOMO" />
                    <span className="text-sm text-gray-400">MOMO</span>
                  </label>
                </div>
              </div>
              <div className="mb-4">
                <input
                  type="text"
                  onChange={(e) => setNumber(e.target.value)}
                  placeholder="Entrer le numéro de carte"
                  className="w-[440px] p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                />
              </div>

              <div className="flex justify-between space-x-4">
                <div className="w-1/2">
                  <input
                    type="text"
                    placeholder="MM/AA"
                    className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                  />
                </div>
                <div className="w-1/2">
                  <input
                    type="text"
                    placeholder="CVV"
                    className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-span-2">
          <div className="bg-white p-6 shadow-lg rounded-lg h-[300px] ">
            <div className="flex flex-col">
              {loading ? <Loader /> : <div className="flex items-center justify-center my-4">
                <div className="flex flex-col items-center justify-center w-32 h-32 bg-yellow-500 rounded-full">
                  <div className="text-2xl">{souscriptions.package_duration.price}</div>
                  <div className="text-1xl">{t("paiement_souscription.chaque")} {souscriptions.package_duration.number_of_months} {t("paiement_souscription.mois")}</div>
                </div>
              </div>}

              <div className="flex justify-center my-1">
                {!loading &&
                  <Button
                    disabled={loader}
                    className="bg-green-500 text-white p-2 rounded hover:bg-green-600 w-[150px]"
                    style={{ borderRadius: "50px", height: "2em" }}
                    onClick={handlePaie}
                  >
                    {t("paiement_souscription.payer_service")}
                  </Button>}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Component */}
      <ModalComponent isVisible={isModalVisible} onClose={handleCloseModal} />
    </div>
  );
};

export default PaieSous;
